import React from 'react';

import { EmptyStateView, Button } from '@atlas/ui';

export default function LayoutErrorFallback() {
  return (
    <EmptyStateView
      className="viewport-height"
      title="internal_error_title"
      description="internal_error_description"
    >
      <Button
        type="primary"
        className="block"
        onClick={() => window.location.reload()}
        label="refresh"
      />
    </EmptyStateView>
  );
}
